<template>
  <div class="content-warp">
    <div class="content-panle bg-white">
      <a-form
        layout="vertical"
        class="search-form"
        :form="listSearchForm"
        @submit.prevent="handleSearchList"
      >
        <a-row :gutter="48">
          <a-col :md="8" :sm="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="访问起止时间：">
              <a-range-picker
                style="width: 350px"
                format="YYYY-MM-DD"
                :placeholder="[
                    $t('visitorMana.reserved.validStartTimeTxt'),
                    $t('visitorMana.reserved.validEndTimeTxt')
                  ]"
                :ranges="searchDateRangesBtn"
                v-decorator="[
                    'dateRange',
                    { initialValue: [moment().subtract(1, 'months'), moment()] }
                  ]"
              />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('visitorMana.reserved.visitorOrgTxt')+ '：'">
              <a-tree-select
                style="width: 180px"
                :dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"
                :placeholder="$t('visitorMana.reserved.visitorOrgTxt')"
                :treeData="orgTreeDownSelectionData"
                :allowClear="true"
                :treeDefaultExpandedKeys="[orgTreeDownSelectionData[0].value || '']"
                v-decorator="[
                'deptId',
                { initialValue: orgTreeDownSelectionData[0].value }
              ]"
              />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('visitorMana.reserved.visitorOrInviterName')+ '：'">
              <a-input
                style="width: 180px"
                type="text"
                v-decorator="['name']"
                :placeholder="$t('visitorMana.reserved.visitorOrInviterName')"
              >
                <a-icon
                  slot="prefix"
                  type="search"
                  style="color:rgba(0,0,0,.25)"
                />
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('visitorMana.reserved.visitorApproveState')+ '：'">
              <a-select
                style="width: 180px"
                type="text"
                v-decorator="['states']"
                mode="multiple"
                :placeholder="$t('visitorMana.reserved.visitorApproveState')"
              >
                <a-select-option v-for="(state,index) in stateList" :key="index" :value="index">{{state}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <template v-for="(item, index) in exFieldSelect">
            <a-col :md="8" :sm="12">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="exFieldConfig[item].name+ '：'" v-if="exFieldConfig[item].type === 1">
                <a-input v-decorator="[`customExFieldIndexItems[${index}][configId]`, {initialValue: item}]" hidden/>
                <a-input style="width: 180px" type="text"
                         v-decorator="[`customExFieldIndexItems[${index}][fuzzyMatchKey]`]"
                         :placeholder="`请输入${exFieldConfig[item].name}`"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="exFieldConfig[item].name+ '：'" v-if="exFieldConfig[item].type === 2">
                <a-input v-decorator="[`customExFieldIndexItems[${index}][configId]`, {initialValue: item}]" hidden/>
                <a-input-number v-decorator="[`customExFieldIndexItems[${index}][rangeFrom][0]`]"
                                style="width: calc( 50% - 16px)"
                                placeholder="最小值"/>
                <span style="display: inline-block;font-size: 20px;  padding-left: 10px; padding-right: 10px"> ~ </span>
                <a-input-number v-decorator="[`customExFieldIndexItems[${index}][rangeFrom][1]`]"
                                style="width: calc( 50% - 16px)"
                                placeholder="最大值"/>

              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="exFieldConfig[item].name" v-if="exFieldConfig[item].type === 3">
                <a-input v-decorator="[`customExFieldIndexItems[${index}][configId]`, {initialValue: item}]" hidden/>
                <a-switch v-decorator="[`customExFieldIndexItems[${index}][fuzzyMatchKey]`]" :value="false"/>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="exFieldConfig[item].name" v-if="exFieldConfig[item].type === 6">
                <a-input v-decorator="[`customExFieldIndexItems[${index}][configId]`, {initialValue: item}]" hidden/>
                <a-select style="width: 180px" v-decorator="[`customExFieldIndexItems[${index}][enumCodes]`]"
                          :placeholder="`请选择${exFieldConfig[item].name}`">
                  <a-select-option v-for="(v,i) in exFieldConfig[item].enums" :key="v.code" :value="v.code">
                    {{ v.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="exFieldConfig[item].name" v-if="exFieldConfig[item].type === 7">
                <a-input v-decorator="[`customExFieldIndexItems[${index}][configId]`, {initialValue: item}]" hidden/>
                <a-select style="width: 180px" v-decorator="[`customExFieldIndexItems[${index}][enumCodes]`]"
                          :placeholder="`请选择${exFieldConfig[item].name}`" mode="multiple">
                  <a-select-option v-for="(v,i) in exFieldConfig[item].enums" :key="v.code" :value="v.code">
                    {{ v.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="exFieldConfig[item].name" v-if="exFieldConfig[item].type === 401">
                <a-input v-decorator="[`customExFieldIndexItems[${index}][configId]`, {initialValue: item}]" hidden/>
                <a-range-picker
                  style="width: 350px"
                  format="YYYY-MM-DD"
                  :placeholder="[
                  $t('visitorMana.reserved.validStartTimeTxt'),
                  $t('visitorMana.reserved.validEndTimeTxt')
                ]"
                  :ranges="searchDateRangesBtn"
                  v-decorator="[`customExFieldIndexItems[${index}][rangeFrom]`]"
                />
            </a-form-item>
              <!-- datetime -->
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="exFieldConfig[item].name" v-if="exFieldConfig[item].type === 403">
                <a-input v-decorator="[`customExFieldIndexItems[${index}][configId]`, {initialValue: item}]" hidden/>
                <a-range-picker
                  show-time
                  format="YYYY-MM-DD HH:mm:ss"
                  dropdownClassName="form-date-picker"
                  :placeholder="[
                    $t('visitorMana.reserved.validStartTimeTxt'),
                    $t('visitorMana.reserved.validEndTimeTxt')
                  ]"
                  :ranges="searchDateRangesBtn"
                  v-decorator="[`customExFieldIndexItems[${index}][rangeFrom]`]"
                />
              </a-form-item>
            </a-col>
          </template>
        </a-row>
        <a-row :gutter="48">
          <a-col style="text-align: right">
            <a-form-item style="margin-right:0">
              <a-popover placement="leftTop" v-model="popoverVisible" trigger="click">
                <template slot="title">
                  <span>扩展字段</span>
                </template>
                <template slot="content">
                  <a-row>
                    <a-checkbox-group v-model="exFieldSelect">
                        <a-checkbox v-for="(i, index) in exFieldConfig" :key="index" :value="index">{{ i.name }}</a-checkbox>
                    </a-checkbox-group>
                  </a-row>
                  <a-row style="text-align: right">
                    <a-button type="primary" size="small" style="margin-right: 10px" @click="popoverSubmit">确定
                    </a-button>
                  </a-row>
                </template>
                <a-button type="primary" :loading="exportLoading" style="margin-right: 10px">扩展字段</a-button>
              </a-popover>
              <a-button type="primary" html-type="submit" style="margin-right: 10px" :loading="loading">{{
                  $t('visitorMana.reserved.searchBtn')
                }}
              </a-button>
              <a-button type="primary" :loading="exportLoading" style="margin-right: 10px"
                        @click="handleExportReservedList">
                {{ $t('visitorMana.reserved.exportBtn') }}
              </a-button>
              <a-button type="primary" :loading="exportLoading" @click="handleCreateApplyRecordShow">
                创建预约记录
              </a-button>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <div class="table-operation-area">
        <div class="btn-area-inline">
          <TableTips :total="pagination.total"/>
        </div>

      </div>

      <a-table
        class="table-area"
        style="min-height: 584px"
        :columns="tableColumns"
        :dataSource="tableData"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
      >
        <span slot="isVisited" slot-scope="text, record">
          <a-tag v-if="text === 1" color="green">{{
              $t('visitorMana.reserved.listVisited')
            }}</a-tag>
          <a-tag v-if="text === 2" color="orange">{{
              $t('visitorMana.reserved.listWaitting')
            }}</a-tag>
          <a-tag v-if="text === 3" color="red">{{
              $t('visitorMana.reserved.listOverdue')
            }}</a-tag>
        </span>

        <span slot="state" slot-scope="text, record">
          <a-tag v-if="text === 2" color="#2db7f5">{{
              $t('visitorMana.reserved.stateWaiting')
            }}</a-tag>
          <a-tag v-if="text === 3" color="#87d068">{{
              $t('visitorMana.reserved.statePass')
            }}</a-tag>
          <a-tag v-if="text === 4" color="red">{{
              $t('visitorMana.reserved.stateRefuse')
            }}</a-tag>
          <a-tag v-if="text === 5" color="#f50">{{
              $t('visitorMana.reserved.stateDelete')
            }}</a-tag>
        </span>
        <template slot="operation" slot-scope="text, record">
          <a-button type="link" icon="profile" class="action-btn"  :disabled="record.operation.disabled"  @click="record.operation.callback(record)" >
            {{ $t(record.operation.type) }}
          </a-button>
          <template v-if="record.state === 2">
            <a-button type="link" class="action-btn" icon="hourglass" :disabled="approveLoading" @click="handleRefuse(record)">审核拒绝 </a-button>
<!--            <a-button type="link" class="action-btn" icon="delete" @click="handleDelete(record)">删除 </a-button>-->
<!--            <a-button type="link" class="action-btn" icon="snippets" >作废 </a-button>-->
          </template>
        </template>
      </a-table>
    </div>

    <!-- 预约访客详情 -->
    <a-modal
      :title="$t('visitorMana.reserved.modalReservationRecordDetail')"
      :visible="detailModalVisible"
      :footer="null"
      width="900px"
      @cancel="
        () => {
          detailModalVisible = false
        }
      "
      :afterClose="handleDetailModalHide"
      :bodyStyle="{ maxHeight: '700px', overflowY: 'auto' }"
    >
      <div v-if="detailModalLoading" class="loading-spin-warp">
        <a-spin tip="Loading..." class="loading-spin"></a-spin>
      </div>
      <div class="content-panle padding-0">
        <!-- 预约访客信息 -->
        <h3 class="panle-head" style="margin-bottom: 24px;">
          {{ $t('visitorMana.reserved.mReservedVisitorTitle') }}
        </h3>
        <a-row :gutter="20" type="flex" justify="start" align="middle">
          <!-- 预约现场照 -->
          <a-col :span="4" class="desc-image-warp">
            <div class="image-content">
              <img
                v-if="!vPhotos"
                src="../../../public/empty_person.png"
                :alt="$t('visitorMana.reserved.mReservedPhoto')"
              />
              <img
                v-else
                :src="vPhotos"
                :alt="$t('visitorMana.reserved.mReservedPhoto')"
              />
            </div>
            <span class="image-title">{{
                $t('visitorMana.reserved.mReservedPhoto')
              }}</span>
          </a-col>
          <!-- 到访签到照 -->
          <a-col :span="4" class="desc-image-warp">
            <div class="image-content">
              <img
                v-if="!vSignInPhotoUrl"
                src="../../../public/empty_person.png"
                :alt="$t('visitorMana.reserved.mSignInPhoto')"
              />
              <img
                v-else
                :src="vSignInPhotoUrl"
                :alt="$t('visitorMana.reserved.mSignInPhoto')"
              />
            </div>
            <span class="image-title">{{
                $t('visitorMana.reserved.mSignInPhoto')
              }}</span>
          </a-col>
          <a-col :span="16" class="padding-0">
            <!-- 访客姓名 -->
            <a-col :span="12" class="desc-text-warp">
              <span class="desc-title">{{
                  $t('visitorMana.reserved.mName')
                }}</span>
              <span class="desc-content">{{ vName }}</span>
            </a-col>
            <!-- 手机号码 -->
            <a-col :span="12" class="desc-text-warp">
              <span class="desc-title">{{
                  $t('visitorMana.reserved.mPhone')
                }}</span>
              <span class="desc-content">{{ vPhone }}</span>
            </a-col>
            <!-- 证件类型 -->
            <a-col :span="12" class="desc-text-warp">
              <span class="desc-title">{{
                  $t('visitorMana.reserved.mCardType')
                }}</span>
              <span class="desc-content">{{ vCardType }}</span>
            </a-col>
            <!-- 车牌号 -->
            <a-col :span="12" class="desc-text-warp">
              <span class="desc-title">{{
                  $t('visitorMana.reserved.mLicense')
                }}</span>
              <span class="desc-content">{{ vLicense }}</span>
            </a-col>
            <!-- 证件号码 -->
            <a-col :span="24" class="desc-text-warp">
              <span class="desc-title">{{
                  $t('visitorMana.reserved.mIDNumber')
                }}</span>
              <span class="desc-content">{{ vIDNumber }}</span>
            </a-col>
            <!-- 签到时间 -->
            <a-col :span="12" class="desc-text-warp">
              <span class="desc-title">{{
                  $t('visitorMana.reserved.mSignInAt')
                }}</span>
              <span class="desc-content">{{ vSignInAt }}</span>
            </a-col>
            <!-- 签到设备 -->
            <a-col :span="12" class="desc-text-warp">
              <span class="desc-title">{{
                  $t('visitorMana.reserved.mSignInDevice')
                }}</span>
              <span class="desc-content">{{ vSignInDevice }}</span>
            </a-col>
            <!-- 签离时间 -->
            <a-col :span="12" class="desc-text-warp">
              <span class="desc-title">{{
                  $t('visitorMana.reserved.mSignOutAt')
                }}</span>
              <span class="desc-content">{{ vSignOutAt }}</span>
            </a-col>
            <!-- 签离设备 -->
            <a-col :span="12" class="desc-text-warp">
              <span class="desc-title">{{
                  $t('visitorMana.reserved.mSignOutDevice')
                }}</span>
              <span class="desc-content">{{ vSignOutDevice }}</span>
            </a-col>
          </a-col>
        </a-row>

        <!-- 预约申请信息 -->
        <h3 class="panle-head" style="margin-bottom: 24px; margin-top:12px">
          {{ $t('visitorMana.reserved.mReserveApplicationTitle') }}
        </h3>
        <a-row :gutter="20">
          <!-- 邀请人 -->
          <a-col :span="12" class="desc-text-warp">
            <span class="desc-title">{{
                $t('visitorMana.reserved.mIName')
              }}</span>
            <span class="desc-content">{{ iName }}</span>
          </a-col>
          <!-- 邀请人组织 -->
          <a-col :span="12" class="desc-text-warp">
            <span class="desc-title">{{
                $t('visitorMana.reserved.mIOrg')
              }}</span>
            <span class="desc-content">{{ iOrg }}</span>
          </a-col>
          <!-- 预约时间 -->
          <a-col :span="24" class="desc-text-warp">
            <span class="desc-title">{{
                $t('visitorMana.reserved.mReservedRange')
              }}</span>
            <span class="desc-content">{{ reservedRange }}</span>
          </a-col>
          <!-- 来访事由 -->
          <a-col :span="12" class="desc-text-warp">
            <span class="desc-title">{{
                $t('visitorMana.reserved.mVisitReason')
              }}</span>
            <span class="desc-content">{{ visitReason }}</span>
          </a-col>
          <!-- 备注 -->
          <a-col :span="12" class="desc-text-warp">
            <span class="desc-title">{{
                $t('visitorMana.reserved.mRemark')
              }}</span>
            <span class="desc-content">{{ remark }}</span>
          </a-col>
        </a-row>
        <!-- 预约扩展信息 -->
        <template v-if="exFieldKeys.length > 0">
          <!-- 预约申请信息 -->
          <h3 class="panle-head" style="margin-bottom: 24px; margin-top:12px">扩展信息</h3>
          <a-row :gutter="20">
            <a-col :span="12" class="desc-text-warp" v-for="(key, index) in exFieldKeys" :key="index">
              <span class="desc-title">{{ exFieldConfig[key].name }}</span>
              <span class="desc-content">{{ getExtValue(key) }}</span>
            </a-col>
          </a-row>
        </template>
        <!-- 同行到访人员 -->
        <h3 class="panle-head" style="margin-bottom: 24px; margin-top:12px">
          {{ $t('visitorMana.reserved.mCompanionTitle') }}
        </h3>
        <a-table
          class="empty-placeholder"
          v-if="!otherVisitor.length"
        ></a-table>
        <a-row
          :gutter="20"
          type="flex"
          justify="start"
          align="middle"
          v-for="(visitor, index) in otherVisitor"
          :key="index"
        >
          <!-- 预约现场照 -->
          <a-col :span="4" class="desc-image-warp">
            <div class="image-content">
              <img
                v-if="!visitor.reservedPhotoUrl"
                src="../../../public/empty_person.png"
                :alt="$t('visitorMana.reserved.mReservedPhoto')"
              />
              <img
                v-else
                :src="visitor.reservedPhotoUrl"
                :alt="$t('visitorMana.reserved.mReservedPhoto')"
              />
            </div>
            <span class="image-title">{{
                $t('visitorMana.reserved.mReservedPhoto')
              }}</span>
          </a-col>
          <!-- 到访签到照 -->
          <a-col :span="4" class="desc-image-warp">
            <div class="image-content">
              <img
                v-if="!visitor.signInPhotoUrl"
                src="../../../public/empty_person.png"
                :alt="$t('visitorMana.reserved.mSignInPhoto')"
              />
              <img
                v-else
                :src="visitor.signInPhotoUrl"
                :alt="$t('visitorMana.reserved.mSignInPhoto')"
              />
            </div>
            <span class="image-title">{{
                $t('visitorMana.reserved.mSignInPhoto')
              }}</span>
          </a-col>
          <a-col :span="16" class="padding-0">
            <!-- 访客姓名 -->
            <a-col :span="12" class="desc-text-warp">
              <span class="desc-title">{{
                  $t('visitorMana.reserved.mName')
                }}</span>
              <span class="desc-content">{{ visitor.name }}</span>
            </a-col>
            <!-- 手机号码 -->
            <a-col :span="12" class="desc-text-warp">
              <span class="desc-title">{{
                  $t('visitorMana.reserved.mPhone')
                }}</span>
              <span class="desc-content">{{ visitor.phone }}</span>
            </a-col>
            <!-- 证件类型 -->
            <a-col :span="12" class="desc-text-warp">
              <span class="desc-title">{{
                  $t('visitorMana.reserved.mCardType')
                }}</span>
              <span class="desc-content">{{ visitor.cardType }}</span>
            </a-col>
            <!-- 车牌号 -->
            <a-col :span="12" class="desc-text-warp">
              <span class="desc-title">{{
                  $t('visitorMana.reserved.mLicense')
                }}</span>
              <span class="desc-content">{{ visitor.license }}</span>
            </a-col>
            <!-- 证件号码 -->
            <a-col :span="24" class="desc-text-warp">
              <span class="desc-title">{{
                  $t('visitorMana.reserved.mIDNumber')
                }}</span>
              <span class="desc-content">{{ visitor.idNumber }}</span>
            </a-col>
            <!-- 签到时间 -->
            <a-col :span="12" class="desc-text-warp">
              <span class="desc-title">{{
                  $t('visitorMana.reserved.mSignInAt')
                }}</span>
              <span class="desc-content">{{ visitor.signInAt }}</span>
            </a-col>
            <!-- 签到设备 -->
            <a-col :span="12" class="desc-text-warp">
              <span class="desc-title">{{
                  $t('visitorMana.reserved.mSignInDevice')
                }}</span>
              <span class="desc-content">{{ visitor.signInDevice }}</span>
            </a-col>
            <!-- 签离时间 -->
            <a-col :span="12" class="desc-text-warp">
              <span class="desc-title">{{
                  $t('visitorMana.reserved.mSignOutAt')
                }}</span>
              <span class="desc-content">{{ visitor.signOutAt }}</span>
            </a-col>
            <!-- 签离设备 -->
            <a-col :span="12" class="desc-text-warp">
              <span class="desc-title">{{
                  $t('visitorMana.reserved.mSignOutDevice')
                }}</span>
              <span class="desc-content">{{ visitor.signOutDevice }}</span>
            </a-col>
          </a-col>
          <div
            v-if="index !== otherVisitor.length - 1"
            class="desc-bottom-line"
          ></div>
        </a-row>
        <template v-if="reservation && !reservation.isSelfExamine && examineInfo">
          <!-- 预约申请信息 -->
          <h3 class="panle-head" style="margin-bottom: 24px; margin-top:12px">审核信息</h3>
          <a-row :gutter="20" v-if="examineInfo.length> 0">
            <a-timeline>
              <a-timeline-item v-for="info in examineInfo" :key="info.id">
                <a-card size="small" :title="info.createdAt" style="width: 400px">
                  <a slot="extra" href="#">审核结果：{{info.isPass? '通过':'拒绝'}}</a>
                  <p>审核人员：{{ getNames(info.examinePerson) }}</p>
                  <p>抄送人员：{{ getNames(info.exCcPeople) }}</p>
                  <p v-if="!info.isPass">拒绝原因：{{info.rejectReason}} </p>
                </a-card>
              </a-timeline-item>
            </a-timeline>
          </a-row>
          <a-row :gutter="20" v-else >
            <a-col>
              <a-empty />
            </a-col>
          </a-row>
        </template>
      </div>
    </a-modal>
    <CreateAppointmentModel
      :visible="createApplyModelShow"
      @submit="handleCreateApplyRecordSubmit"
      @onClose="() => createApplyModelShow = false"
    />
  </div>
</template>

<script>
import TableTips from '@/components/TableTips'
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'
import { getVisitorApplyByAppointmentId } from '@/api/visitorMana'
import { getReservedVisitor, getReservedDetail } from '@/api/reserveMana'
import { downLoadFileViaAjaxPost } from '../../utils/utils'
import CreateAppointmentModel from './components/CreateAppointmentModel'
import { getUserConfig } from '../../api/userMana'
import { approvalApply } from '../../api/reserveMana'
import { showAppointmentApplyExamine } from '../../api/visitorPath'

export default {
  name: 'reservedVisitor',
  components: {
    TableTips,
    CreateAppointmentModel
  },
  data() {
    const formLayout = {
      labelCol: {
        lg: { span: 10 },
        sm: { span: 10 }
      },
      wrapperCol: {
        xs: { span: 8 },
        sm: { span: 16 }
      }
    }
    return {
      listSearchForm: this.$form.createForm(this),
      labelCol:{sm: { span: 8 }},
      wrapperCol:{ sm: { span: 16 }},
      searchDeptFullName: '',
      searchName: '',
      states: [],
      searchFromDate: moment().subtract(1, 'months').format('YYYY-MM-DD'),
      searchToDate: moment().format('YYYY-MM-DD'),
      // 有效期 date-range-picker
      searchDateRangesBtn: this.getSearchDateRangesBtn(),

      loading: false, // 列表内容是否在加载中
      exportLoading: false, // 列表内容是否在导出中
      tableData: [], // 列表数据源
      tableColumns: this.getTableColumns(), // 列表表头项
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },

      detailModalVisible: false,
      detailModalLoading: false,

      vPhotos: '',
      vSignInPhotoUrl: '',
      vName: '',
      vPhone: '',
      vCardType: '',
      vLicense: '',
      vIDNumber: '',
      vSignInAt: '',
      vSignOutAt: '',
      vSignInDevice: '',
      vSignOutDevice: '',

      iName: '',
      iOrg: '',
      reservedRange: '',
      visitReason: '',
      remark: '',

      otherVisitor: [],

      createApplyModelShow: false,
      createApplyModelLoading: false,

      exFieldConfig: {},
      exFieldValue: {},
      exFieldKeys: [],
      exFieldSelect: [],
      popoverVisible: false,
      customExFieldIndexItems: [],
      stateList:{
        2:"待审核",
        3:"审核通过",
        4:"审核拒绝",
        5:"审核取消",
      },
      approveLoading: false,
      examineInfo: null,
      reservation: null,
    }
  },
  computed: {
    ...mapState({
      lang: 'lang',
      enumsData: state => state.enumsStore.enumsData,
      orgTreeSourceData: state => state.orgStore.orgTreeSourceData
    }),
    ...mapGetters(['orgTreeDownSelectionData', 'orgAutoCompletedSourceData'])
  },
  watch: {
    lang: function (lang) {
      this.tableColumns = this.getTableColumns()
      this.searchDateRangesBtn = this.getSearchDateRangesBtn()
    }
  },
  created() {
    this.idType = {}
    this.getSettings()
    this.handleSearchList()
    this.enumsData.idType.forEach(item => {
      this.idType[item.value] = item.title
    })
  },
  methods: {
    moment,
    getTableColumns() {
      return [
        {
          title: this.$t('visitorMana.reserved.listVisitorName'),
          dataIndex: 'visitor',
          width: '10%'
        },
        {
          title: this.$t('visitorMana.reserved.listVisitorPhone'),
          dataIndex: 'visitorPhone',
          width: '120px'
        },
        {
          title: this.$t('visitorMana.reserved.listLicensePlate'),
          dataIndex: 'carNumber',
          width: '10%'
        },
        {
          title: this.$t('visitorMana.reserved.listInviter'),
          dataIndex: 'inviter',
          width: '10%'
        },
        {
          title: this.$t('visitorMana.reserved.listInviterOrg'),
          dataIndex: 'deptFullName',
          width: '20%'
        },
        {
          title: this.$t('visitorMana.reserved.listAppointmentTime'),
          dataIndex: 'expiryDate',
          width: '180px'
        },
        {
          title: this.$t('visitorMana.reserved.listIsVisited'),
          dataIndex: 'isVisited',
          width: '9%',
          scopedSlots: { customRender: 'isVisited' }
        },
        {
          title: this.$t('visitorMana.reserved.state'),
          dataIndex: 'state',
          width: '9%',
          scopedSlots: { customRender: 'state' }
        },
        {
          title: this.$t('visitorMana.reserved.listOperation'),
          dataIndex: 'operation',
          width: '80px',
          scopedSlots: { customRender: 'operation' }
        }
      ]
    },
    // 获取时间段选择插件快捷按钮内容
    getSearchDateRangesBtn() {
      const btns = {}
      btns[this.$t('visitorMana.reserved.aWeekBeforeBtn')] = [
        this.moment().subtract(6, 'days'),
        this.moment()
      ]
      btns[this.$t('visitorMana.reserved.oneMonthBeforeBtn')] = [
        this.moment().subtract(1, 'months'),
        this.moment()
      ]
      btns[this.$t('visitorMana.reserved.threeMonthsBeforeBtn')] = [
        this.moment().subtract(3, 'months'),
        this.moment()
      ]
      return btns
    },
    // 搜索列表
    handleSearchList() {
      this.listSearchForm.validateFields((err, values) => {
        if (!err) {
          if (Object.keys(values).length > 0) {
            this.searchDeptFullName = values.deptId ? this.orgAutoCompletedSourceData.find(
              org => org.id === values.deptId
            ).name: ''
            this.states = values.states || []
            this.searchName = values.name
            console.log(values.dateRange)
            this.searchFromDate = values.dateRange[0].format('YYYY-MM-DD')
            this.searchToDate = values.dateRange[1].format('YYYY-MM-DD')

            if (values.customExFieldIndexItems){
              let extFieldsSearchItems = []
              let items = values.customExFieldIndexItems
              items.forEach(t=>{
                let param = {}
                let id = t.configId
                param.configId = id
                let config = this.exFieldConfig[id]
                let type = config.type
                // enumCodes	枚举匹配值列表，表示包含列表中任一值即满足条件。适用于单选、多选类型  6,7
                // fuzzyMatchKey 匹配关键字。字符串、手机号、身份证号类型使用模糊匹配；布尔类型使用精确匹配； 1,3
                // rangeFrom , rangeTo 范围匹配起始值，包含该值。适用于数字、日期、时间、日期时间类型	 2 401, 403
                if (t.fuzzyMatchKey && (type === 1 || type === 3)){
                  param.fuzzyMatchKey = t.fuzzyMatchKey + ''
                  extFieldsSearchItems.push( param )
                }
                if ( t.enumCodes && (type === 6 || type === 7) ){
                  let codes = []
                  if ( type === 6 ){
                    codes = [t.enumCodes]
                  }else{
                    codes = t.enumCodes
                  }
                  if (codes.length>0){
                    param.enumCodes = codes
                    extFieldsSearchItems.push( param )
                  }
                }
                if (t.rangeFrom && t.rangeFrom.length === 2 && ( type === 2 || type === 401 || type === 403 )){
                  let one = t.rangeFrom[0]
                  let two = t.rangeFrom[1]
                  if (type === 401){
                    one = one.format('YYYY-MM-DD')
                    two = two.format('YYYY-MM-DD')
                  }
                  if (type === 403){
                    one = one.format('YYYY-MM-DD HH:mm:ss')
                    two = two.format('YYYY-MM-DD HH:mm:ss')
                  }
                  if (one !== undefined && two !== undefined){
                    param.rangeFrom = one
                    param.rangeTo = two
                    extFieldsSearchItems.push( param )
                  }
                }
              })
              this.customExFieldIndexItems = extFieldsSearchItems
            }
          }
          this.pagination.current = 1
          this.getListData()
        }
      })
    },
    // 获取列表数据
    async getListData() {
      try {
        this.loading = true
        const res = await getReservedVisitor({
          initiatorDeptFullName:this.searchDeptFullName ,
          appointmentStartFrom: this.searchFromDate,
          appointmentStartTo: this.searchToDate,
          customExFieldIndexItems: this.customExFieldIndexItems,
          name: this.searchName,
          states: this.states,
          perPage: this.pagination.pageSize,
          page: this.pagination.current
        })
        this.loading = false

        this.tableData = this.createReservedTableData(res)
        this.pagination.total = res.data.size
      } catch (error) {
        this.loading = false
      }
    },
    getNames(val) {
      let names = []
      if (!val) {
        return "无"
      }

      if (typeof val === 'object' && !Array.isArray(val)) {
        return val.name
      }

      for (var i = 0; i < val.length; i++) {
        let item = val[i]
        names.push(item.name)
      }
      let name = names.join("，")
      return name === '' ? '无' : name
    },
    createReservedTableData(res) {
      const serverTimeStamp = res.data.meta.timestamp
      return res.data.collection.map(item => {
        const isOverdue = serverTimeStamp > Date.parse(item.appointmentEnd)
        // 1: 已到访；2: 未到访；3: 已过期
        const visitedCode = item.hasVisitor ? 1 : isOverdue ? 3 : 2

        return {
          key: item.appointmentVisitorId,
          id: item.appointmentVisitorId,
          visitor: item.appointmentVisitorName,
          visitorPhone: item.appointmentVisitorPhone,
          carNumber: item.appointmentVisitorCarNumber,
          inviter: item.initiatorName,
          deptFullName: item.initiatorDeptFullName,
          expiryDate: `${item.appointmentStart} ~ ${item.appointmentEnd}`,
          appointmentId: item.appointmentId,
          scenePhotoUrl: item.scenePhotoUrl,
          idCard: item.appointmentVisitorCertificationTypeName,
          idNumber: item.appointmentVisitorIdNumber,
          isVisited: visitedCode,
          state: item.state,
          operation: {
            type: 'visitorMana.reserved.listDetailBtn',
            callback: this.handleVisitorDetail
          }
        }
      })
    },
    // 点击分页时触发
    handleTableChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.getListData()
    },

    // 查看访客详情
    handleVisitorDetail(data) {
      this.detailModalVisible = true
      this.detailModalLoading = true

      Promise.all([
        // 预约申请详情请求
        getReservedDetail({ id: data.appointmentId }),
        // 预约申请相关的预约人员到访信息请求
        getVisitorApplyByAppointmentId({ id: data.appointmentId })
      ])
        .then(resArr => {
          // console.log(resArr)
          const reservation = resArr[0].data.collection[0]
          const visited = resArr[1].data.collection[0]
          if (!reservation.isSelfExamine){
            showAppointmentApplyExamine({appointmentApplyId: reservation.id}).then(res=>{
              if(res && res.data.collection){
                _this.examineInfo = res.data.collection[0].appointmentApplyExamineNodeResults || null
              }
            })
          }
          let otherVisitor = {}
          if (visited) {
            visited.visitors.forEach(v => {
              otherVisitor[v.appointmentVisitorId] = v
            })
          }

          // // 分离当前访客、同行访客
          // let currentVisitor = [],otherVisitor = []
          // if (visited) {
          //   otherVisitor = visited.visitors
          //   currentVisitor = otherVisitor.filter(
          //     (visitor, index, otherVisitor) => {
          //       if (visitor.appointmentVisitorId === data.id) {
          //         otherVisitor.splice(index, 1)
          //         return visitor
          //       }
          //     }
          //   )
          // }else{
          //   otherVisitor = reservation.appointmentVisitors
          //   console.log(reservation.appointmentVisitors, otherVisitor)
          //   currentVisitor = otherVisitor.filter(
          //     (visitor, index, otherVisitor) => {
          //       if (visitor.id === data.id) {
          //         otherVisitor.splice(index, 1)
          //         return visitor
          //       }
          //     }
          //   )
          //   console.log(currentVisitor[0])
          // }
          //获取所有的拜访人员
          let others = []
          let appointmentVisitors = reservation.appointmentVisitors
          let _this = this
          appointmentVisitors.forEach(visitor => {
            let signInfo = otherVisitor[visitor.id]
            if (visitor.id === data.id) {
              //查找签到信息
              if (signInfo) {
                let {
                  signIn,
                  signOut
                } = getSignInfo(signInfo.signs)
                _this.vSignInPhotoUrl = signIn ? signIn.scenePhotoUrl : ''
                _this.vSignInAt = signIn ? signIn.signAt : ''
                _this.vSignInDevice = signIn ? signIn.signDeviceTypeName : ''
                _this.vSignOutAt = signOut ? signOut.signAt : ''
                _this.vSignOutDevice = signOut ? signOut.signDeviceTypeName : ''
              }
            } else {
              let res = {
                reservedPhotoUrl: visitor.scenePhotoUrl,
                name: visitor.name,
                phone: visitor.phoneNumber,
                cardType: this.idType[visitor.certificationTypeCode],
                idNumber: visitor.idNumber,
                license: visitor.carNumber,
              }
              if (signInfo) {
                // 到访人员签到、签离
                let {
                  signIn,
                  signOut
                } = getSignInfo(signInfo.signs)
                res = Object.assign(res, {
                  signInPhotoUrl: signIn ? signIn.scenePhotoUrl : '',
                  signInAt: signIn ? signIn.signAt : '',
                  signInDevice: signIn ? signIn.signDeviceTypeName : '',
                  signOutAt: signOut ? signOut.signAt : '',
                  signOutDevice: signOut ? signOut.signDeviceTypeName : ''
                })
              }
              others.push(res)
            }
          })
          this.otherVisitor = others
          // 预约访客信息
          this.vPhotos = data.scenePhotoUrl
          this.vName = data.visitor
          this.vPhone = data.visitorPhone
          this.vCardType = data.idCard
          this.vIDNumber = data.idNumber
          this.vLicense = data.carNumber
          // if (currentVisitor && currentVisitor[0]) {
          //   let { signIn, signOut } = getSignInfo(currentVisitor[0].signs)
          //   this.vSignInPhotoUrl = signIn ? signIn.scenePhotoUrl : ''
          //   this.vSignInAt = signIn ? signIn.signAt : ''
          //   this.vSignInDevice = signIn ? signIn.signDeviceTypeName : ''
          //   this.vSignOutAt = signOut ? signOut.signAt : ''
          //   this.vSignOutDevice = signOut ? signOut.signDeviceTypeName : ''
          // }

          // 预约申请信息
          this.iName = reservation.initiatorName
          this.iOrg = reservation.initiatorDeptFullName
          this.reservedRange = `${reservation.appointmentStart} ~ ${reservation.appointmentEnd}`
          this.visitReason = reservation.reason
          this.remark = reservation.remark

          // 同行访客
          // this.otherVisitor = otherVisitor.map(visitor => {
          //   // 到访人员签到、签离
          //   let { signIn, signOut } = getSignInfo(visitor.signs)
          //
          //   return {
          //     reservedPhotoUrl: visitor.scenePhotoUrl,
          //     signInPhotoUrl: signIn ? signIn.scenePhotoUrl : '',
          //     name: visitor.name,
          //     phone: visitor.phoneNumber,
          //     cardType: this.idType[visitor.certificationTypeCode],
          //     idNumber: visitor.idNumber,
          //     license: visitor.carNumber,
          //     signInAt: signIn ? signIn.signAt : '',
          //     signInDevice: signIn ? signIn.signDeviceTypeName : '',
          //     signOutAt: signOut ? signOut.signAt : '',
          //     signOutDevice: signOut ? signOut.signDeviceTypeName : ''
          //   }
          // })
          this.reservation = reservation
          //扩展信息
          this.exFieldValue = reservation.exFieldValue
          this.detailModalLoading = false
        })
        .catch(err => {
          this.detailModalLoading = false
        })

      function getSignInfo(signs) {
        let signIn, signOut
        signs.forEach(item => {
          if (item.signType === 1) signIn = item
          if (item.signType === 2) signOut = item
        })

        return {
          signIn,
          signOut
        }
      }
    },
    // 关闭预约访客详情模态框
    handleDetailModalHide() {
      // console.log('--handleDetailModalHide--')
      this.detailModalLoading = false

      // 预约访客信息
      this.vPhotos = ''
      this.vName = ''
      this.vPhone = ''
      this.vCardType = ''
      this.vIDNumber = ''
      this.vLicense = ''
      this.vSignInPhotoUrl = ''
      this.vSignInAt = ''
      this.vSignInDevice = ''
      this.vSignOutAt = ''
      this.vSignOutDevice = ''
      // 预约申请信息
      this.iName = ''
      this.iOrg = ''
      this.reservedRange = ''
      this.visitReason = ''
      this.remark = ''
      // 同行访客
      this.otherVisitor = []
    },
    async handleExportReservedList() {
      this.listSearchForm.validateFields((err, values) => {
        if (!err) {
          this.searchDeptFullName = this.orgAutoCompletedSourceData.find(
            org => org.id === values.deptId
          ).name
          this.searchName = values.name
          this.searchFromDate = values.dateRange[0].format('YYYY-MM-DD')
          this.searchToDate = values.dateRange[1].format('YYYY-MM-DD')

          this.exportLoading = true
          downLoadFileViaAjaxPost(
            '/face/web/appointment/export_appointment_visitor',
            {
              initiatorDeptFullName:
                this.searchDeptFullName ||
                this.orgTreeDownSelectionData[0].fullName,
              appointmentStartFrom: this.searchFromDate,
              appointmentStartTo: this.searchToDate,
              name: this.searchName
            },
            `${this.$t('visitorMana.reserved.exportFilePrefix')}(${this.searchFromDate} ~ ${this.searchToDate})`,
            'xlsx',
            () => {
              this.exportLoading = false
              this.$notification.success({
                message: this.$t('visitorMana.reserved.exportSuccess')
              })
            }
          )
          this.exportLoading = false
        }
      })
    },
    handleCreateApplyRecordShow() {
      this.createApplyModelShow = true
    },
    handleCreateApplyRecordHide() {
      this.createApplyModelShow = false
    },
    handleCreateApplyRecordSubmit() {
      this.handleCreateApplyRecordHide()
      this.handleSearchList()
    },
    async getSettings() {
      let _this = this
      try {
        const res = await getUserConfig()
        const {
          appointmentApplyCustomExFieldConfig
        } = res.data.collection[0]
        let exFieldConfig = {}
        if (appointmentApplyCustomExFieldConfig) {
          let exFields = JSON.parse(appointmentApplyCustomExFieldConfig)
          exFields.forEach(item => {
            exFieldConfig[item.id] = item
          })
        }
        let newkeys = []
        let keys = Object.keys(exFieldConfig)
        keys.forEach((key) => {
          let item = exFieldConfig[key]
          let order = item.order
          newkeys.splice(order, 0, key)
        })
        _this.exFieldConfig = exFieldConfig
        _this.exFieldKeys = newkeys
      } catch (e) {

      }
    },
    getExtValue(id) {
      let config = this.exFieldConfig[id]
      let type = config.type
      let val = this.exFieldValue.hasOwnProperty(id) ? this.exFieldValue[id] : undefined
      //单选
      if (type === 3) {
        return val === undefined ? '无' : (val ? '是' : '否')
      }
      let name = val ? val : ''
      if (type === 6) {
        let enums = config.enums
        enums.forEach(item => {
          if (item.code === val) {
            name = item.name
          }
        })
        return name === '' ? '无' : name
      }
      if (type === 7) {
        let enums = config.enums
        let nameList = []
        enums.forEach(item => {
          if (val && val.includes(item.code)) {
            nameList.push(item.name)
          }
        })
        name = nameList.join('，')
        return name === '' ? '无' : name
      }
      return name === '' ? '无' : name
    },
    hidePopover() {
      this.popoverVisible = false
    },
    popoverSubmit() {
      this.popoverVisible = false
    },
    handleRefuse(data){
      console.log(data)
      let _this = this
      this.$confirm({
        title: '审核拒绝操作',
        content: '拒绝后，预约申请将不参与后续审核，流程结束！',
        okText: this.$t('orgMana.confirmBtn'),
        cancelText: this.$t('orgMana.cancelBtn'),
        onOk: ()=>{
          _this.approveLoading = true
          approvalApply({appointmentApplyId: data.appointmentId}).then(res=>{
            _this.$notification.success({message: '审核完成'})
            _this.approveLoading = false
            _this.handleSearchList()
          }).catch(res=>{
            _this.approveLoading = false
          })
        },
        onCancel() {}
      })
    },
  }
}
</script>
<style>
.empty-placeholder .ant-table-placeholder {
  border: unset;
  padding: 0;
}

.empty-placeholder .ant-table-placeholder > .ant-empty-normal {
  margin: 20px 0;
}
</style>
<style scoped>
.loading-spin-warp {
  width: 100%;
  position: absolute;
  left: 0;
  top: 55px;
  bottom: 0;
  background-color: rgba(230, 247, 255, 0.5);
  z-index: 1;
}

.loading-spin-warp > .loading-spin {
  position: absolute;
  top: 50%;
  left: 45%;
  margin-top: -23px;
}

.desc-text-warp {
  padding-bottom: 24px;
}

.desc-text-warp .desc-title {
  display: inline-block;
  text-align: right;
  width: 100px;
  position: relative;
  color: rgba(0, 0, 0, 0.85);
}

.desc-text-warp .desc-title:after {
  content: ':';
  position: absolute;
  right: -5px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 1.5;
}

.desc-text-warp .desc-content {
  display: inline-block;
  width: calc(100% - 100px);
  padding-left: 15px;
  vertical-align: top;
  line-height: 1.5;
}

.desc-image-warp {
  padding-bottom: 24px;
}

.desc-image-warp .image-content {
  height: 170px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.desc-image-warp .image-content > img {
  max-height: 100%;
  max-width: 100%;
}

.desc-image-warp .image-title {
  display: block;
  width: 100%;
  text-align: center;
  margin-top: 5px;
}

.desc-bottom-line {
  width: 100%;
  border-bottom: 1px solid #e8e8e8;
  margin: 24px 0;
}
.ant-form-item .ant-input,
.ant-form-item .ant-input-affix-wrapper,
.ant-form-item .ant-select,
.ant-form-item .ant-calendar-picker,
.ant-form-item .ant-calendar-picker{ width: 100% !important;}

.action-btn{
  font-size: 12px;
  height: 22px;
}

/deep/ .ant-form-item-label {
  text-align: right !important;
  padding-bottom: 0 !important;
  margin-top: 5px;
}
</style>
